import apis from '@/utils/apis';

// 交易状态
const TRADE_STATUS = {
  // 未交易
  NOT_TRADED: {
    val: 0
  },
  // 正在交易
  TRADING: {
    val: 1
  },
  // 免收中
  FREEING: {
    val: 2
  },
  // 待确认收款
  WAIT_CONFIRM_COLLECTION: {
    val: 6
  },
  // 交易完成
  TRADE_FINISH: {
    val: 10
  },
  // 交易拒绝
  TRADE_REJECT: {
    val: 90
  },
  // 交易关闭
  TRADE_CLOSE: {
    val: 100
  },
  // 已免收
  TRADE_FREE: {
    val: 11
  }
};

// 开票情况
const BILL_STATUS = {
  // 待开票 1
  WAIT_INVOICE: {
    val: 0
  },
  // 第一次开票 1
  HAS_INVOICE: {
    val: 1
  },
  // 已冲红
  RED: {
    val: 2
  },
  // 第二次开票
  SECOND: {
    val: 3
  }
};

// 操作权限配置
const ACTION_AUTH = {
  // 付款登记
  PAY_REGISTER: {
    tradeStatus: [TRADE_STATUS.NOT_TRADED.val, TRADE_STATUS.TRADING.val],
    billStatus: []
  },
  // 查看付款记录
  CHECK_PAYMENT_INFO: {
    tradeStatus: [TRADE_STATUS.TRADE_FINISH.val],
    billStatus: []
  },
  // 撤销付款
  CANCEL_PAYMENT: {
    tradeStatus: [TRADE_STATUS.WAIT_CONFIRM_COLLECTION.val],
    billStatus: []
  },
  // 查看申请免收信息
  CHECK_APPLY_FREE_MSG: {
    tradeStatus: [TRADE_STATUS.TRADE_FREE.val],
    billStatus: []
  },
  // 确认收款
  CONFIRM_COLLECTION: {
    tradeStatus: [TRADE_STATUS.WAIT_CONFIRM_COLLECTION.val],
    billStatus: []
  },
  // 登记收款
  REGISTER_COLLECTION: {
    tradeStatus: [TRADE_STATUS.NOT_TRADED.val, TRADE_STATUS.TRADING.val],
    billStatus: []
  },
  // 查看收款信息
  CHECK_COLLECTION_INFO: {
    tradeStatus: [TRADE_STATUS.TRADE_FINISH.val],
    billStatus: []
  },
  // 撤销免收
  CANCEL_FREE: {
    tradeStatus: [TRADE_STATUS.TRADE_FREE.val],
    billStatus: []
  },
  // 撤销收款
  CANCEL_COLLECTION: {
    tradeStatus: [TRADE_STATUS.TRADE_FINISH.val],
    billStatus: [BILL_STATUS.WAIT_INVOICE.val]
  },
  // 延期收款
  DELAY_COLLECTION: {
    tradeStatus: [TRADE_STATUS.NOT_TRADED.val],
    billStatus: []
  }
};

export default {
  data() {
    return {
      TRADE_STATUS,
      BILL_STATUS,
      // 是否自动调用 this.getDictionaryCodeValue('bill_type');
      loadBillType: true
    };
  },
  methods: {
    formatTermNum(row) {
      // 除了租赁账单,销售单外，其他账单期数显示 -
      if (this.dicCodeValue.bill_type && this.dicCodeValue.bill_type.term) {
        const checkTypes = [
          `${this.dicCodeValue.bill_type.term}`,
          `${this.dicCodeValue.bill_type.sales_fee}`,
          `${this.dicCodeValue.bill_type.sales_part}`,
          `${this.dicCodeValue.bill_type.sales_data}`,
        ];
        if (checkTypes.includes(`${row.billType}`)) {
          return [row.termNum, row.totalTerm].join('/');
        }
      }
      return '-';
    },
    /**
     * 检测权限
     * @param {object | array<object>} row 可以为单项，可以为列表
     * @param {string} auth 权限名称 付款登记:PAY_REGISTER 开票申请:INVOICE
     * 查看付款记录:CHECK_PAYMENT_INFO 撤销付款:CANCEL_PAYMENT 申请免收：APPLY_FREE
     * 查看收款记录:CHECK_COLLECTION_INFO
     * 查看申请免收信息：CHECK_APPLY_FREE_MSG 确认收款 CONFIRM_COLLECTION
     * 登记收款：REGISTER_COLLECTION
     * 取消免收：CANCEL_FREE
     * 撤销收款：CANCEL_COLLECTION
     * 延期收款：DELAY_COLLECTION
     * @return {boolean} ret 是否有权限
     */
    checkAuth(row, auth) {
      let flag = true;
      const checkRule = ACTION_AUTH[auth];
      const rows = Array.isArray(row) ? row : [row];

      // 申请免收
      if (auth === 'APPLY_FREE') {
        return !rows.some(item => item.billTradeState !== TRADE_STATUS.NOT_TRADED.val);
      }

      // 开票申请
      if (auth === 'INVOICE') {
        // invoiceWaitState 账单待开票状态 1-待提交 2-已提交
        // 开票金额: paymentAmount -invoiceAmount -lockInvoiceAmount(账单金额 - 已开票金额 - 锁定开票金额)
        // 账单待开票状态-待提交  && 开票金额 > 0  && 账单类型不为押金 && 账单状态不为（已免收，已关闭）

        // 账单类型不为押金
        let billTypeCheck = true;
        if (this.dicCodeValue.bill_type && this.dicCodeValue.bill_type.deposit) {
          billTypeCheck = !rows.some((item) => {
            const isDeposit = `${this.dicCodeValue.bill_type.deposit}` === `${item.billType}`;
            return isDeposit;
          });
        }

        // 账单状态不为（已免收，已关闭）
        const billTradeStateCheck = !rows.some(item => [TRADE_STATUS.TRADE_CLOSE.val, TRADE_STATUS.TRADE_FREE.val].includes(item.billTradeState));

        return (
          billTradeStateCheck
          // 账单类型不为押金
          && billTypeCheck
          // 账单待开票状态-待提交
          && !rows.some(item => item.invoiceWaitState !== 1)
          // 开票金额 > 0
          && !rows.some((item) => {
            const { paymentAmount = 0, invoiceAmount = 0, lockInvoiceAmount = 0 } = item;
            const ret = paymentAmount - invoiceAmount - lockInvoiceAmount <= 0;
            return ret;
          })
        );
      }

      rows.forEach((obj) => {
        if (checkRule.tradeStatus.length) {
          if (!checkRule.tradeStatus.includes(obj.billTradeState)) {
            flag = false;
          }
        }
        if (checkRule.billStatus.length) {
          if (!checkRule.billStatus.includes(obj.billInvoiceState)) {
            flag = false;
          }
        }
      });
      return flag;
    },
    // 获取紧急天数
    getUrgent(row) {
      const { billPaymentTime } = row;
      if (billPaymentTime) {
        const billPaymentTimeMs = new Date(billPaymentTime).getTime();
        const curMs = new Date().getTime();
        const diff = Math.round((billPaymentTimeMs - curMs) / (24 * 3600 * 1000));
        return diff;
      }
      return '';
    },
    // 获取紧急天数显示文本
    getUrgentView(row) {
      const num = this.getUrgent(row);
      if (typeof num === 'number') {
        if (num >= 0) {
          return [num, '天'].join('');
        } else {
          return '已过期';
        }
      }
      return '-';
    },
    // 应付-金额总额
    getPayTotal(rows) {
      const list = Array.isArray(rows) ? rows : [rows];
      return list.reduce((sum, row) => {
        const { paymentAmount = 0, overdueAmount = 0, breakAmount = 0 } = row;
        const ret = paymentAmount + overdueAmount + breakAmount;
        return ret + sum;
      }, 0);
    },
    // 付款登记
    payRegister(row) {
      const rows = Array.isArray(row) ? [...row] : [row];
      const id = this.getUUID();
      this.setSession(id, rows);
      this.jump('/rent/myAccount/payConfirm', {
        id
      });
    },
    // 查看付款信息
    checkPaymentInfo(row) {
      const rows = Array.isArray(row) ? [...row] : [row];
      const id = this.getUUID();
      this.setSession(id, rows);
      const path = this.$route.path;
      this.jump(`${path}/paymentInfo`, {
        id,
        type: 'watch'
      });
    },
    /**
     * 获取fms模块balance值
     * @param {object} data 账单详情接口返回的数据
     * @return {number} ret
     */
    getBalance(data) {
      const billPayment = data.billPayment || {
        totalPaymentAmount: 0,
        totalTradeAmount: 0,
        tradeBalanceAmount: 0,
        tradeState: 1
      };
      const partnerBalance = data.partnerBalance || {
        balanceAmount: 0,
        lockAmount: 0
      };
      const totalPaymentAmount = billPayment.totalPaymentAmount || 0;
      const totalTradeAmount = billPayment.totalTradeAmount || 0;
      const tradeBalanceAmount = billPayment.tradeBalanceAmount || 0;
      const tradeState = billPayment.tradeState || 1;
      const balanceAmount = partnerBalance.balanceAmount || 0;
      const lockAmount = partnerBalance.lockAmount || 0;
      if (tradeState === 1) {
        return balanceAmount - lockAmount;
      }

      if (totalPaymentAmount - totalTradeAmount >= 0) {
        return balanceAmount - lockAmount + totalPaymentAmount - totalTradeAmount;
      } else {
        return balanceAmount - lockAmount === 0 ? tradeBalanceAmount : balanceAmount - lockAmount;
      }
    },
    // 获取暂存url
    getStockReqUrl() {
      return apis.paymentProvisionalSave;
      // const billType = `${type}`;
      // let ret = '';
      // switch (billType) {
      //   case '13':
      //     ret = apis.billPaymentProvisionalSaveOverdue;
      //     break;
      //   case '20':
      //     ret = apis.refundRentSave;
      //     break;
      //   case '100':
      //     ret = apis.billPaymentProvisionalSaveStock;
      //     break;
      //   case '10':
      //     ret = apis.billPaymentProvisionalSave;
      //     break;
      //   case '11': // 押金暂存
      //     ret = apis.provisionalSave;
      // }
      // return ret;
    },
    // 获取提交url
    getSubmitReqUrl() {
      return apis.paymentRegister;
      // const billType = `${type}`;
      // let ret = '';
      // switch (billType) {
      //   case '13':
      //     ret = apis.billPaymentRegisterOverdue;
      //     break;
      //   case '20':
      //     ret = apis.refundRentSubmit;
      //     break;
      //   case '100':
      //     ret = apis.billPaymentRegisterStock;
      //     break;
      //   case '10':
      //     ret = apis.billPaymentRegisterTerm;
      //     break;
      //   case '11':
      //     ret = apis.depositRegisterSave;
      // }
      // return ret;
    },
    // 如果是退款账单，应付金额要格式化为负数
    formatRefundBill(list, key = 'paymentAmount') {
      return list.map((item) => {
        const ret = {
          ...item
        };
        if (item.isRefundBill) {
          const amount = item[key] || 0;
          ret[key] = Math.abs(amount) * -1;
        }

        return ret;
      });
    }
  },
  mounted() {
    if (this.loadBillType) {
      this.getDictionaryCodeValue('bill_type');
    }
  }
};
